var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataFoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 759,
    height: 560,
    viewBox: "0 0 759 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2384_53657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.416 230.833C102.416 353.009 241.359 452.053 412.755 452.053C584.15 452.053 723.092 353.009 723.092 230.833C723.092 108.657 584.15 9.61298 412.755 9.61298C241.359 9.61298 102.416 108.657 102.416 230.833Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 532.953C0 544.989 63.4271 554.748 141.668 554.748C219.909 554.748 283.336 544.989 283.336 532.953C283.336 520.916 219.909 511.157 141.668 511.157C63.4271 511.157 0 520.916 0 532.953Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29 537.312C117.29 549.349 231.874 559.106 373.22 559.106C514.567 559.106 629.151 549.349 629.151 537.312C629.151 525.274 514.567 515.517 373.22 515.517C231.874 515.517 117.29 525.274 117.29 537.312Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.596 0.0132231C277.168 0.734556 255.301 21.9026 253.781 48.2972C252.886 63.8172 258.901 77.9399 269.022 87.9039C270.518 89.3759 271.213 91.4746 270.864 93.5439L267.062 116.039L290.45 102.411C291.782 101.635 293.353 101.349 294.864 101.655C300.581 102.807 306.638 103.02 312.882 102.075C335.988 98.5732 354.014 79.4452 356.145 56.1732C358.985 25.1572 334.212 -0.82011 303.596 0.0132231Z",
    fill: "#C8D7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.818 78.253C301.818 77.6237 301.987 77.1036 302.326 76.6916C302.664 76.281 303.126 76.0743 303.706 76.0743C304.383 76.0743 304.867 76.2677 305.159 76.6557C305.45 77.0437 305.594 77.5757 305.594 78.253C305.594 78.833 305.436 79.3423 305.123 79.7783C304.807 80.213 304.335 80.4316 303.706 80.4316C303.076 80.4316 302.604 80.237 302.29 79.8503C301.975 79.4637 301.818 78.9317 301.818 78.253ZM302.69 69.1023L302.544 56.829C304.335 56.393 305.97 55.825 307.446 55.1223C308.922 54.421 310.218 53.609 311.331 52.689C312.444 51.7703 313.376 50.741 314.128 49.6023C314.878 48.4663 315.446 47.2423 315.835 45.9343C316.222 44.6276 316.416 43.249 316.416 41.7956C316.416 39.7143 315.907 37.7543 314.89 35.913C313.874 34.0743 312.42 32.585 310.532 31.4463C308.644 30.309 306.394 29.7397 303.779 29.7397C300.971 29.7397 298.368 30.5156 295.972 32.0636C293.575 33.6143 291.747 36.2517 290.488 39.9797L289.182 39.109C290.295 35.5757 292.159 32.8637 294.774 30.9757C297.388 29.0863 300.366 28.1423 303.706 28.1423C306.563 28.1423 309.068 28.749 311.223 29.9583C313.376 31.169 315.059 32.8036 316.27 34.861C317.479 36.9183 318.087 39.2303 318.087 41.7956C318.087 43.733 317.759 45.549 317.106 47.2423C316.452 48.937 315.532 50.4863 314.346 51.8903C313.159 53.2956 311.719 54.517 310.024 55.557C308.328 56.5996 306.418 57.385 304.287 57.9183L304.143 69.1023H302.69Z",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.043 502.281L157.32 519.444C157.32 519.444 200.015 537.63 196.055 537.893C192.094 538.157 130.739 534.198 130.739 534.198L134.351 503.038L155.043 502.281Z",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.148 222.073C143.148 222.073 139.746 254.82 137.194 256.521C134.642 258.223 131.24 259.073 131.24 259.073L136.769 221.648L143.148 222.073Z",
    stroke: "#333436",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7284 199.564C75.7284 199.564 58.4232 238.641 63.4471 260.412L159.374 245.78L157.374 205.185L75.7284 199.564Z",
    fill: "#FDC732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.375 245.78C159.375 245.78 159.919 339.533 160.585 372.197C161.252 404.861 166.964 505.736 166.964 505.736C166.964 505.736 149.051 515.612 130.393 507.63C128.901 506.992 112.829 244.905 112.829 244.905L159.375 245.78Z",
    fill: "#FDC732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0363 248.808L24.5576 506.592C24.5576 506.592 42.2347 523.153 64.5643 508.081L105.724 297.516L125.712 284.096L128.689 245.686L65.0363 248.808Z",
    fill: "#FDC732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4078 500.21L58.0932 515.018C58.0932 515.018 85.0281 547.413 81.0589 547.413C77.0896 547.413 32.8604 527.359 32.8604 527.359L38.5307 496.507L54.4078 500.21Z",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8225 215.381C79.8225 215.381 54.3127 322.632 35.3496 511.988",
    stroke: "#333436",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3132 226.918C97.3132 226.918 88.3813 249.246 73.123 249.62",
    stroke: "#333436",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.042 509.176L121.99 287.269L134.74 273.898",
    stroke: "#333436",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.872 87.2946C141.509 85.9359 146.353 84.9612 146.353 84.9612L187.75 107.571C187.82 107.609 187.89 107.648 187.961 107.687C201.526 115.172 207.522 127.872 207.166 145.671L209.177 171.453L186.744 153.248L167.78 189.817L155.736 232.989C91.4636 256.361 66.498 214.399 66.498 214.399L87.7934 168.3L96.3944 125.727C100.48 103.883 113.1 91.7519 134.872 87.2946Z",
    fill: "#EE91F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.084 231.076C348.084 231.076 379.525 254.788 432.663 240.761C432.663 240.761 423.719 221.809 400.588 218.51C377.457 215.212 342.316 226.218 348.084 231.076Z",
    fill: "#63A368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.084 231.076C348.084 231.076 384.523 216.836 432.663 240.761C432.663 240.761 438.315 243.724 442.709 250.453",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.544 214.733C471.901 214.733 479.994 211.801 486.412 206.447L504.217 191.588C510.625 186.241 518.237 183.376 526.034 183.376H614.405C622.425 183.376 628.925 189.877 628.925 197.896V214.733V517.821C628.925 531.66 617.708 542.877 603.87 542.877H163.346C152.584 542.877 143.858 534.152 143.858 523.389V234.223C143.858 223.459 152.584 214.733 163.346 214.733H463.544Z",
    fill: "#B0E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.86 525.021C143.86 525.021 173.84 468.784 176.839 462.326L258.773 295.404C260.833 290.969 265.28 288.131 270.171 288.131H574.647C585.716 288.131 601.725 282.329 610.224 275.237L622.511 264.985C628.917 259.639 636.529 256.773 644.328 256.773H728.427C737.377 256.773 743.459 265.867 740.039 274.14L638.344 520.099C632.644 533.885 619.196 542.877 604.276 542.877H149.359C146.393 542.877 143.656 540.337 143.657 537.372L143.86 525.021Z",
    fill: "#6CC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.706 304.004L147.476 537.718",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.247 344.278H420.813C423.637 344.278 426.265 342.857 427.781 340.51C431.281 335.096 427.331 328.009 420.813 328.009H317.247C314.423 328.009 311.795 329.43 310.279 331.777C306.779 337.192 310.729 344.278 317.247 344.278Z",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.98 424.606L430.344 472.647",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.051 422.292L495.719 472.937",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.472 409.412C415.844 424.054 403.55 453.309 418.014 474.753C432.478 496.197 468.223 501.71 497.851 487.068C527.48 472.425 539.775 443.171 525.311 421.728C510.847 400.284 475.102 394.769 445.472 409.412Z",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.434 196.29L179.388 213.082C179.388 213.082 165.36 229.634 151.112 219.83L148.826 216.553L164.434 196.29Z",
    fill: "#EE91F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.688 96.0974C129.688 96.0974 150.177 101.465 134.057 160.693",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.689 198.052C154.628 185.624 141.108 170.008 133.121 159.241",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.112 219.831C140.497 208.948 126.151 193.455 119.89 187.713C110.132 178.765 100.006 164.368 103.307 145.872L102.91 131.043",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.837 211.883C201.764 204.819 195.741 196.073 190.7 189.591C178.673 174.128 174.412 172.213 177.936 154.216L178.129 135.381L204.221 163.619C214.185 176.837 237.156 200.531 245.642 209.867C245.642 209.867 235.681 223.144 214.837 211.883Z",
    fill: "#EE91F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.625 207.113C162.828 206.784 164.076 206.682 165.316 206.813C169.791 207.286 181.781 208.545 183.133 208.562C184.8 208.584 186.155 206.097 189.732 215.116C193.308 224.134 192.665 224.974 192.645 226.153C192.624 227.332 190.031 244.65 187.243 242.049C184.456 239.448 184.831 237.933 184.831 237.933C184.831 237.933 183.328 244.966 182.537 244.694C181.747 244.424 178.817 244.414 179.287 239.449C179.287 239.449 177.689 244.276 176.043 243.076C174.396 241.876 174.765 236.657 174.765 236.657C174.765 236.657 173.003 240.574 170.989 237.958C168.977 235.342 170.477 229.285 170.477 229.285L168.789 224.785L165.141 223.208C165.141 223.208 152.856 226.421 150.744 217.894C149.12 211.342 157.608 208.212 161.625 207.113Z",
    fill: "#F3977F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.334 218.17L188.642 227.862L184.831 237.933",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.412 217.812L183.4 227.747L179.287 239.449",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.219 218.92L176.957 228.472L174.967 235.626",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.187 34.7556C160.827 38.8356 160.764 43.7969 160.764 43.7969C160.764 43.7969 159.265 41.9462 157.412 41.3529",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.448 204.339C231.593 203.337 235.964 204.013 239.759 205.959C244.752 208.517 252.553 212.48 253.569 212.784C255.08 213.235 256.065 212.417 256.265 221.592C256.345 225.217 256.333 227.72 256.011 228.787C255.687 229.855 248.359 240.804 245.952 239.263C245.887 239.22 245.841 239.185 245.783 239.145C245.172 239.964 244.355 240.969 243.552 241.655C242.951 242.168 239.604 242.099 241.316 237.703C241.316 237.703 238.996 242.783 237.192 242.107C234.841 241.224 235.223 238.964 236.08 237.051C234.988 238.527 233.636 239.728 232.675 238.451C230.788 235.948 235.061 227.041 235.061 227.041L235.56 221.648L232.297 218.728C232.297 218.728 220.641 219.015 220.924 210.711C221.055 206.905 224.141 205.137 227.448 204.339Z",
    fill: "#F3977F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.031 218.232L252.884 228.07L245.708 238.51",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.936 218.309L247.376 228.449L241.316 237.703",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.763 218.575L242.036 227.115L236.865 235.692",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.013 216.299C228.013 216.299 229.183 225.101 226.343 227.033C223.503 228.965 218.922 210.764 222.072 210.531C226.688 210.189 228.013 216.299 228.013 216.299Z",
    fill: "#F3977F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.885 215.026C231.885 215.026 229.06 215.48 228.252 218.798",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.056 172.433L190.789 154.536C203.344 137.926 194.977 120.368 194.977 120.368",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.177 171.453C209.177 171.453 201.087 160.236 199.248 165.201",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.304 78.1011L209.975 77.6104",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.607 75.9333L146.353 84.9613C146.353 84.9613 145.9 105.439 165.277 121.004L173.979 112.549L182.748 121.321C182.748 121.321 186.083 118.7 187.075 106.812L185.511 92.3759L163.607 75.9333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.511 92.376L163.607 75.9333L146.354 84.9613",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.598 79.0373C158.598 79.0373 163.934 110.229 171.831 112.44C179.73 114.649 184.656 99.052 184.656 99.052L169.362 56.4719L158.598 79.0373Z",
    fill: "#F3977F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.589 102.802L187.683 106.68C187.756 106.72 187.525 107.878 183.68 108.318C166.785 107.814 165.448 88.805 164.073 73.681C164.073 73.681 189.148 99.7837 187.589 102.802Z",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.232 60.3971C211.232 60.3971 215.572 99.9331 192.38 106.358C169.188 112.782 163.632 74.9612 164.432 61.8825C165.232 48.8012 171.763 42.3425 188.018 41.7558C212.064 40.8892 211.232 60.3971 211.232 60.3971Z",
    fill: "#F3977F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.511 49.6813C176.511 49.6813 176.076 57.9906 170.562 59.6506L166.596 71.8706C166.596 71.8706 163.274 66.44 159.623 64.516C159.623 64.516 155.591 48.3786 160.667 41.9666C165.743 35.5546 172.799 32.304 189.87 33.7226C202.863 34.804 210.464 44.0213 212.947 48.7093C213.752 50.2306 215.706 54.5026 211.139 58.6586C211.139 58.6586 211.2 55.5133 208.534 51.8359C208.534 51.8359 202.312 64.5546 176.511 49.6813Z",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.276 73.9663C155.706 79.1823 159.81 82.6316 163.442 81.6689C167.076 80.7063 168.861 75.6969 167.43 70.4796C166.001 65.2623 161.897 61.8129 158.264 62.7769C154.632 63.7396 152.845 68.7489 154.276 73.9663Z",
    fill: "#F3977F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.715 75.7092C187.649 77.0519 188.287 78.1772 189.141 78.2199C189.995 78.2639 190.741 77.2092 190.807 75.8665C190.873 74.5225 190.235 73.3972 189.381 73.3545C188.527 73.3105 187.781 74.3652 187.715 75.7092Z",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.603 76.8129C205.471 78.0729 205.987 79.1596 206.755 79.2422C207.523 79.3236 208.252 78.3689 208.384 77.1102C208.517 75.8502 208.001 74.7636 207.233 74.6822C206.465 74.5996 205.735 75.5542 205.603 76.8129Z",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.609 65.0651C182.609 65.0651 188.752 66.3825 189.161 60.5558",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.423 64.5877C203.423 64.5877 204.988 70.0024 209.607 66.8677",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.642 97.3677C186.642 97.3677 184.616 89.1157 178.331 93.8464L186.642 97.3677Z",
    fill: "#040606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.921 69.4238C157.921 69.4238 162.008 65.9092 164.24 72.3358C164.24 72.3358 161.853 74.8691 163.36 76.8571C163.36 76.8571 161.006 77.3918 159.845 75.3158",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.69 71.8823C159.69 71.8823 159.918 70.4543 161.504 68.825",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.056 76.6093C202.056 80.4279 204.404 83.5239 207.298 83.5239C210.194 83.5239 212.541 80.4279 212.541 76.6093C212.541 72.7906 210.194 69.6946 207.298 69.6946C204.404 69.6946 202.056 72.7906 202.056 76.6093Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.435 75.6636C182.435 79.7102 185.423 82.9902 189.109 82.9902C192.795 82.9902 195.783 79.7102 195.783 75.6636C195.783 71.6169 192.795 68.3356 189.109 68.3356C185.423 68.3356 182.435 71.6169 182.435 75.6636Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.293 78.6118C202.293 78.6118 200.669 71.7238 195.405 78.1225",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.576 72.8906L167.068 69.3973",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.941 81.657C203.709 82.633 203.869 83.7944 203.482 85.0504C203.098 86.2904 201.836 87.045 200.554 87.0184C199.962 87.0064 199.392 86.845 198.832 86.6703C198.586 86.593 198.1 86.3304 197.837 86.4477C196.558 87.013 195.068 85.897 195.494 85.025",
    stroke: "#040606",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2384_53657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 759,
    height: 559.107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFoundIcon);
export default __webpack_public_path__ + "static/media/no-data-found-icon.154f88509b338f380e6641280e2d7161.svg";
export { ForwardRef as ReactComponent };